var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#CC3300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.7281C7.5 10.3163 7.79357 9.98247 8.15571 9.98247L10.4203 9.98207C10.8703 9.9691 11.2672 9.64378 11.4203 9.1625C11.4243 9.14985 11.429 9.13424 11.4456 9.0776L11.5432 8.74468C11.6029 8.54055 11.6549 8.36271 11.7277 8.20375C12.0153 7.57576 12.5474 7.13967 13.1622 7.02802C13.3179 6.99976 13.4827 6.99988 13.6719 7.00002H16.6282C16.8174 6.99988 16.9823 6.99976 17.1379 7.02802C17.7528 7.13967 18.2849 7.57576 18.5725 8.20375C18.6453 8.36271 18.6973 8.54055 18.757 8.74468L18.8546 9.0776C18.8712 9.13424 18.8758 9.14985 18.8798 9.1625C19.0329 9.64378 19.5086 9.9695 19.9586 9.98247H22.1443C22.5064 9.98247 22.8 10.3163 22.8 10.7281C22.8 11.1399 22.5064 11.4737 22.1443 11.4737H8.15571C7.79357 11.4737 7.5 11.1399 7.5 10.7281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8063 24H15.4937C17.859 24 19.0417 24 19.8106 23.247C20.5796 22.4939 20.6583 21.2587 20.8156 18.7882L21.0423 15.2285C21.1277 13.8881 21.1704 13.2178 20.7846 12.7931C20.3989 12.3684 19.7474 12.3684 18.4446 12.3684H11.8554C10.5526 12.3684 9.90115 12.3684 9.51539 12.7931C9.12964 13.2178 9.17232 13.8881 9.25769 15.2285L9.4844 18.7882C9.64174 21.2587 9.72041 22.4939 10.4894 23.247C11.2583 24 12.441 24 14.8063 24ZM17.9093 15.7938C17.9444 15.425 17.6888 15.0961 17.3384 15.0593C16.9881 15.0224 16.6757 15.2914 16.6407 15.6602L16.2157 20.1339C16.1806 20.5027 16.4362 20.8315 16.7866 20.8684C17.1369 20.9053 17.4493 20.6362 17.4843 20.2674L17.9093 15.7938ZM12.9616 15.0593C13.3119 15.0224 13.6243 15.2914 13.6593 15.6602L14.0843 20.1339C14.1194 20.5027 13.8638 20.8315 13.5134 20.8684C13.1631 20.9053 12.8507 20.6362 12.8157 20.2674L12.3907 15.7938C12.3556 15.425 12.6112 15.0961 12.9616 15.0593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.46e395c4b560c0d94b89a193adaff45c.svg";
export { ForwardRef as ReactComponent };